var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthenticationPending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 104,
    viewBox: "0 0 120 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_10269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2282 57.8772L100.264 34.761V79.5879C100.264 80.4549 99.7985 81.2671 99.0411 81.696L64.2253 101.801L61.4419 103.407C60.6845 103.845 59.7536 103.845 59.0053 103.407L56.2218 101.801L21.4061 81.696C20.6487 81.258 20.1832 80.4549 20.1832 79.5879V34.761L60.219 57.8772H60.2282Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1923 34.761L60.2281 11.6448L100.264 34.761L60.2281 57.8771L20.1923 34.761Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1923 34.761L60.2281 57.8771L100.264 34.761L60.2281 11.6448L20.1923 34.761Z",
    fill: "#C1E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4787 93.9888L54.4879 87.1443L42.4872 80.0717L42.478 86.9162L54.4787 93.9888Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2282 57.8772L40.8171 69.0839C40.443 69.3029 39.9775 69.3029 39.5942 69.0839L1.27414 46.9533C0.790457 46.6704 0.790457 45.9677 1.27414 45.6848L20.1924 34.761L60.2282 57.8772Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2281 11.6448L79.6392 0.438072C80.0133 0.219048 80.4788 0.219048 80.8621 0.438072L119.191 22.5686C119.675 22.8516 119.675 23.5543 119.191 23.8372L100.273 34.761L60.2281 11.6448Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2281 57.8772L79.6392 69.0839C80.0133 69.3029 80.4788 69.3029 80.8621 69.0839L119.191 46.9533C119.675 46.6704 119.675 45.9677 119.191 45.6848L100.273 34.761L60.2373 57.8772H60.2281Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2282 11.6448L40.8263 0.438072C40.4521 0.219048 39.9867 0.219048 39.6034 0.438072L1.27414 22.5686C0.790457 22.8516 0.790457 23.5543 1.27414 23.8372L20.1924 34.761L60.2282 11.6448Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2281 57.8772V103.726",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2555 45.4475C72.7298 45.4475 82.8423 35.3351 82.8423 22.8607C82.8423 10.3863 72.7298 0.273804 60.2555 0.273804C47.7811 0.273804 37.6686 10.3863 37.6686 22.8607C37.6686 35.3351 47.7811 45.4475 60.2555 45.4475Z",
    fill: "#0C57BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2372 13.1597V24.6676",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2372 32.5615H60.2646",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_10269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119.642,
    height: 104,
    fill: "white",
    transform: "translate(0.178955)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthenticationPending);
export default __webpack_public_path__ + "static/media/authentication_pending.13864169739de59bf2fb1591606bc4b8.svg";
export { ForwardRef as ReactComponent };